import { Component, inject, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { SolarInformationen } from '../../../domain/model/solar-informationen.model';
import { AbstractForm } from '../abstract-form.model';
import { FormGroupConfig } from '../form-config.model';
import { ErzeugungsanlageConfig } from '../erzeugungsanlage.config';
import { SolarAbsenkung70Item } from '../../../domain/model/solar-absenkung-70.enum';
import { PredicateValidator } from '../validator/predicate.validator';
import { MatValidators } from '../../../common/material/components/mat-form-field-required.directive';
import { LeistungsValidator } from '../validator/leistungs.validator';
import { Feld } from '../../../domain/model/feld.enum';

@Component({
    selector: 'redispatch-solar-sub-form',
    templateUrl: './solar-sub-form.component.html',
    styleUrls: [
        './solar-sub-form.component.scss',
    ],
    standalone: false,
})
export class SolarSubFormComponent extends AbstractForm<SolarInformationen> {

    public readonly LYT_GAP = ErzeugungsanlageConfig.HORIZONTAL_FX_LAYOUT_GAP;
    public readonly AUSRICHTUNG_MIN = 0;
    public readonly AUSRICHTUNG_MAX = 360;
    public readonly NEIGUNGSWINKEL_MIN = 0;
    public readonly NEIGUNGSWINKEL_MAX = 90;
    public readonly GANZZALIG_PATTERN = new RegExp('^\\d*$');

    @Input({ required: true }) disabled: boolean;
    @Input({ required: true }) readonly: boolean;

    @Input({ required: true }) isSpitzOrSpitzLight = false;
    @Input({ required: true }) spitzOrSpitzLightHint: string = '';
    @Input({ required: true }) absenkung70Hint: string = '';

    public readonly SolarAbsenkung70Items = SolarAbsenkung70Item.getAll();
    public readonly Feld = Feld;

    constructor() {
        super(inject(UntypedFormBuilder));
    }

    get formGroupConfig(): FormGroupConfig<SolarInformationen> {
        return {
            wechselrichterleistungKumuliert: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    ...LeistungsValidator.validator3,
                ],
            ],
            ausrichtungPvModuleGrad: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                [
                    PredicateValidator.conditionalValidator(() => this.isSpitzOrSpitzLight, Validators.required),
                    Validators.min(this.AUSRICHTUNG_MIN),
                    Validators.max(this.AUSRICHTUNG_MAX),
                    Validators.pattern(this.GANZZALIG_PATTERN),
                ],
            ],
            neigungswinkelPvModuleGrad: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                [
                    PredicateValidator.conditionalValidator(() => this.isSpitzOrSpitzLight, Validators.required),
                    Validators.min(this.NEIGUNGSWINKEL_MIN),
                    Validators.max(this.NEIGUNGSWINKEL_MAX),
                    Validators.pattern(this.GANZZALIG_PATTERN),
                ],
            ],
            absenkung70: [
                {
                    value: null,
                    disabled: true, // is an "readonly" field
                },
            ],
        };
    }

    public sanitize(infos: SolarInformationen): SolarInformationen {
        infos.absenkung70 = this.f.absenkung70.value; // needed due to "readonly field"
        return infos;
    }
}
